import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes without conflicts (shadcn/ui pattern).
 * Combines clsx for conditional classes with tailwind-merge for dedup.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
